var chunkToChildrenMap = {
	"2831": [
		8768,
		3387
	],
	"3147": [
		8768,
		3387
	],
	"5839": [
		8240
	],
	"6254": [
		8768,
		3387
	],
	"7552": [
		8849,
		7343,
		5266,
		6628,
		5839
	],
	"8117": [
		8849,
		7343,
		5831,
		8379,
		3832,
		6834
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));